import React, { useState } from "react";
import { MdOutlineMail } from "react-icons/md";

const ExportDataUI = ({
  assessments = [],
  onExport,
  selectedAssessment,
  onSelectAssessment,
  selectedCandidates,
  onSelectCandidates,
  isModalOpen,
  onClose,
}) => {
  const [selectedDateRange, onSelectDateRange] = useState("");
  const [selectedScoreRange, onSelectScoreRange] = useState("");
  const [selectedAssessment1, setSelectedAssessment1] = useState("");
  const [isCustomDate, setIsCustomDate] = useState(false);
  const [isCustomScore, setIsCustomScore] = useState(false);
  const [currentTab, setCurrentTab] = useState(-1);
  // const [isModalOpen, setIsModalOpen] = useState(false);

  const ExportFormat = [
    { name: "Pdf", action: () => setCurrentTab(0), id: 0 },
    { name: "Xls", action: () => setCurrentTab(1), id: 1 },
    { name: "Csv", action: () => setCurrentTab(2), id: 2 },
    { name: "Json", action: () => setCurrentTab(3), id: 3 },
  ];

  const [presentTab, setPresentTab] = useState(-1);
  const CandidateSelection = [
    { name: "All candidates", action: () => setPresentTab(0), id: 0 },
    { name: "Shortlisted candidates", action: () => setPresentTab(1), id: 1 },
    { name: "On Hold candidates", action: () => setPresentTab(2), id: 2 },
    { name: "Rejected Candidates", action: () => setPresentTab(3), id: 3 },
  ];

  const handleDateRangeChange = (e) => {
    const value = e.target.value;
    if (value === "custom") {
      setIsCustomDate(true);
    } else {
      setIsCustomDate(false);
    }
  };

  const handleScoreRangeChange = (e) => {
    const value = e.target.value;
    if (value === "custom") {
      setIsCustomScore(true);
    } else {
      setIsCustomScore(false);
    }
  };

  return (
    <div>
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
          <div className="max-w-3xl mx-auto p-12 bg-white rounded-lg shadow-md relative">
            <button
              onClick={() => onClose()}
              className="absolute top-2 right-2 text-gray-500"
            >
              &times;
            </button>
            <div className="flex items-baseline">
              <div className="flex top-3 bg-primary2 border w-10 h-10 rounded-3xl justify-center items-center relative">
                <MdOutlineMail className="" />
              </div>
              <h2 className="text-lg font-bold ml-4">Export data</h2>
            </div>
            <p className="text-sm text-gray-500 mb-3 ml-14">
              Select any one option from below
            </p>

            {/* Assessment Dropdown */}
            <div className="mb-10">
              <label className="block text-sm font-semibold mb-2">
                Select assessment
              </label>
              <select
                value={selectedAssessment1}
                onChange={(e) => {
                  setSelectedAssessment1(e.target.value);
                }}
                className="w-full border border-gray-300 text-primary rounded-lg p-2"
              >
                <option className="text-gray-500" value="assessment">
                  All assessments
                </option>
                <option className="text-gray-500" value="assessment1">
                  Assessment 1
                </option>
                <option className="text-gray-500" value="assessment2">
                  Assessment 2
                </option>
                {assessments.map((assessment) => (
                  <option key={assessment.id} value={assessment.id}>
                    {assessment.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="grid grid-cols-2 gap-4 mb-6">
              <div>
                <label className="block text-sm font-semibold mb-2">
                  Date Range
                </label>
                <select
                  value={selectedAssessment}
                  onChange={onSelectAssessment}
                  className="w-full border border-gray-300 text-primary rounded-lg p-2"
                  onClick={(e) => handleDateRangeChange(e)}
                >
                  <option className="text-gray-500" value="">
                    All dates
                  </option>
                  <option className="text-gray-500" value="lastWeek">
                    last week
                  </option>
                  <option className="text-gray-500" value="last15Days">
                    last 15 days
                  </option>
                  <option className="text-gray-500" value="last30Days">
                    last 30 days
                  </option>
                  <option className="text-gray-500" value="custom">
                    custom dates
                  </option>
                </select>

                {isCustomDate && (
                  <div className="grid grid-cols-2 gap-4 mb-6">
                    <div>
                      <label className="block text-xs font-normal mt-4">
                        Start date
                      </label>
                      <input
                        type="date"
                        onChange={(e) =>
                          onSelectDateRange("start", e.target.value)
                        }
                        className="w-full border border-gray-300 text-sm rounded-lg p-1"
                      />
                    </div>

                    <div>
                      <label className="block text-xs font-normal mt-4">
                        End date
                      </label>
                      <input
                        type="date"
                        onChange={(e) =>
                          onSelectDateRange("end", e.target.value)
                        }
                        className="w-full border border-gray-300 text-sm rounded-lg p-1"
                      />
                    </div>
                  </div>
                )}
              </div>

              <div>
                <label className="block text-sm font-semibold mb-2">
                  Score Range
                </label>
                <select
                  value={selectedAssessment}
                  onChange={onSelectAssessment}
                  className="w-full border border-gray-300 text-primary rounded-lg p-2"
                  onClick={(e) => handleScoreRangeChange(e)}
                >
                  <option className="text-gray-500" value="">
                    All scores
                  </option>
                  <option className="text-gray-500" value="above90">
                    Above 90%
                  </option>
                  <option className="text-gray-500" value="70-89">
                    70-89%
                  </option>
                  <option className="text-gray-500" value="below70">
                    less than 70%
                  </option>
                  <option className="text-gray-500" value="custom">
                    custom score
                  </option>
                </select>

                {isCustomScore && (
                  <div className="grid grid-cols-2 gap-4 mb-6">
                    <div>
                      <label className="block text-xs font-normal mt-4">
                        Minimum score (%)
                      </label>
                      <input
                        type="number"
                        onChange={(e) =>
                          onSelectScoreRange("min", e.target.value)
                        }
                        className="w-full border border-gray-300 text-sm rounded-lg p-1"
                        placeholder="Minimum score"
                        min={0}
                        max={100}
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-normal mt-4">
                        Maximum score (%)
                      </label>
                      <input
                        type="number"
                        onChange={(e) =>
                          onSelectScoreRange("max", e.target.value)
                        }
                        className="w-full border border-gray-300 text-sm rounded-lg p-1"
                        placeholder="Maximum score"
                        min={0}
                        max={100}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Candidates Selection */}
            <div className="mb-6">
              <label className="block text-sm font-semibold mb-2">
                Select Candidates
              </label>
              <div className="flex items-center justify-between">
                {CandidateSelection.map((label) => (
                  <div
                    key={label.id}
                    className={`flex items-center gap-2 ${
                      presentTab === label.id ? "text-primary" : "text-gray-500"
                    }`}
                  >
                    <input
                      type="checkbox"
                      onChange={() => label.action}
                      className="rounded-none border-gray-300"
                    />
                    <span className="text-sm">{label.name}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Export Format */}
            <div className="mb-6">
              <label className="block text-2xl font-normal mb-4">
                Select Export Format
              </label>

              <div className="flex items-center justify-between">
                {ExportFormat.map((format) => (
                  <div
                    key={format.id}
                    className={`flex items-center ${
                      currentTab === format.id
                        ? "border border-primary"
                        : "border border-gray-500"
                    } px-5 min-w-[10vw] py-2 rounded-lg justify-between relative`}
                  >
                    <span className="text-sm">{format.name}</span>

                    <input
                      type="radio"
                      name="exportFormat"
                      onChange={format.action}
                      className="peer h-3 w-3 cursor-pointer appearance-none rounded-full border border-slate-300 checked:border-primary"
                    />

                    <div className="absolute bg-primary w-2 h-2 rounded-full opacity-0 peer-checked:opacity-100 top-1/2 right-[1.12em] transform -translate-x-1/2 -translate-y-1/2"></div>
                  </div>
                ))}
              </div>
            </div>

            {/* Export Button */}
            <div className="text-right">
              <button
                onClick={onExport}
                className="bg-orange-500 mr-72 text-black py-2 px-6 rounded-lg justify-center items-center"
              >
                Export
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExportDataUI;
